import React, { useMemo, useState } from "react";
import sets from "../../data/stills.json";
import "./Stills.css";

function Stills() {
  const [activeSlug, setActiveSlug] = useState(null);

  const activeSet = useMemo(
    () => sets.find((s) => s.slug === activeSlug) || null,
    [activeSlug]
  );

  const goHome = () => setActiveSlug(null);

  // ====== VIEW 1: FOLDER CARDS ======
  if (!activeSet) {
    return (
      <section className="Stills" id="main">
        <h1 className="Stills__title">Stills</h1>

        <div className="Stills__folderGrid">
          {sets.map((set) => {
            const cover = set.cover || set.images?.[0] || "";
            return (
              <button
                key={set.slug}
                type="button"
                className="Stills__folderCard"
                onClick={() => setActiveSlug(set.slug)}
                aria-label={`${set.label} folder`}
              >
                <div
                  className="Stills__folderMedia"
                  style={{ backgroundImage: `url('${cover}')` }}
                >
                  <div className="Stills__folderOverlay">
                    <div className="Stills__folderText">
                      <div className="Stills__folderLabel">{set.label}</div>
                    </div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </section>
    );
  }

  // ====== VIEW 2: GALLERY (masonry, no crop) ======
  return (
    <section className="Stills Stills--gallery" id="main">
      <div className="Stills__header">
        <h1 className="Stills__title">{activeSet.label}</h1>
        <button
          className="Stills__back"
          onClick={goHome}
          aria-label="Back to folders"
        >
          ← Back
        </button>
      </div>

      <div className="Stills__grid">
        {activeSet.images?.map((src, i) => (
          <div key={i} className="Stills__tile">
            <img
              className="Stills__img"
              src={src}
              alt={`${activeSet.label} ${i + 1}`}
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Stills;
